import { SafeResourceUrl } from '@angular/platform-browser';
import { createAction, props } from '@ngrx/store';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { CommonTurnViewModel } from 'src/app/model/common/turn.view';

enum CommonTurnLabel {
  SET_RESULT = 'COMMON_TURN_SET_RESULT',
  ADD_RESULT = 'COMMON_TURN_ADD_RESULT',
  PATCH_RESULT = 'COMMON_TURN_PATCH_RESULT',
  DELETE_RESULT = 'COMMON_TURN_DELETE_RESULT',
  SET_QUERY_RESULT = 'COMMON_TURN_SET_QUERY_RESULT',
  CLEAN_RESULT = 'COMMON_TURN_CLEAN_RESULT',
  SET_ALL_DEFAULT = 'COMMON_TURN_SET_ALL_DEFAULT',
  SET_LAZY_LOAD_RESULT = 'COMMON_TURN_SET_LAZY_LOAD_RESULT',
  SAVE_TURN_FORM = 'COMMON_TURN_SAVE_TURN_FORM',
  GENERATED_RECIPE = 'COMMON_TURN_GENERATED_RECIPE',
}

export const commonTurnActions = {
  setResultAction: createAction(
    CommonTurnLabel.SET_RESULT,
    props<{ result: CommonTurnViewModel[] }>()
  ),
  addResultAction: createAction(
    CommonTurnLabel.ADD_RESULT,
    props<CommonTurnViewModel>()
  ),
  patchResultAction: createAction(
    CommonTurnLabel.PATCH_RESULT,
    props<CommonTurnViewModel>()
  ),
  deleteResultAction: createAction(
    CommonTurnLabel.DELETE_RESULT,
    props<{ turn: number }>()
  ),
  setQueryResultAction: createAction(
    CommonTurnLabel.SET_QUERY_RESULT,
    props<{ key: string; value: string }>()
  ),
  cleanResultAction: createAction(CommonTurnLabel.CLEAN_RESULT, props<any>()),
  setAllDefaultAction: createAction(
    CommonTurnLabel.SET_ALL_DEFAULT,
    props<any>()
  ),
  setLazyLoadResultAction: createAction(
    CommonTurnLabel.SET_LAZY_LOAD_RESULT,
    props<VonPageResponseModel<CommonTurnViewModel>>()
  ),
  saveTurnFormAction: createAction(
    CommonTurnLabel.SAVE_TURN_FORM,
    props<{ turn: CommonTurnViewModel; formSaved: boolean }>()
  ),
  generatedRecipeAction: createAction(
    CommonTurnLabel.GENERATED_RECIPE,
    props<{ recipeFile?: SafeResourceUrl; showRecipePdf: boolean }>()
  ),
};
